import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

import { fromEvent } from 'rxjs';
import { map, pairwise, filter } from 'rxjs/operators';

interface ScrollPosition {
  sH: number;
  sT: number;
  cH: number;
}

const DEFAULT_SCROLL_POSITION: ScrollPosition = {
  sH: 0,
  sT: 0,
  cH: 0,
};

@Directive({
  selector: '[appScroll]',
})
export class ScrollDirective implements AfterViewInit {
  private scrollEvent$;

  private userScrolledDown$;

  private requestOnScroll$;
  @Input()
  scrollCallback;

  @Input()
  immediateCallback;

  @Input()
  scrollPercent = 99;

  constructor(private elm: ElementRef) {}

  ngAfterViewInit() {
    this.registerScrollEvent();

    this.streamScrollEvents();

    this.requestCallbackOnScroll();
  }

  private registerScrollEvent() {
    this.scrollEvent$ = fromEvent(this.elm.nativeElement, 'scroll');
  }

  private streamScrollEvents() {
    this.userScrolledDown$ = this.scrollEvent$.pipe(
      map(
        // tslint:disable-next-line:no-any
        (e: any): ScrollPosition => ({
          sH: e.target.scrollHeight,
          sT: e.target.scrollTop,
          cH: e.target.clientHeight,
        }),
      ),
      pairwise(),
      filter((positions) => this.isUserScrollingDown(positions) && this.isScrollExpectedPercent(positions[1])),
    );
  }

  private requestCallbackOnScroll() {
    let shouldCall = true;
    this.requestOnScroll$ = this.userScrolledDown$;

    if (this.immediateCallback) {
      this.requestOnScroll$ = this.requestOnScroll$.startWith([DEFAULT_SCROLL_POSITION, DEFAULT_SCROLL_POSITION]);
    }

    this.requestOnScroll$.subscribe((value) => {
      if (shouldCall) {
        this.scrollCallback().then(() => (shouldCall = true));
        shouldCall = false;
      }
    });
  }

  private isUserScrollingDown = (positions) => {
    return positions[0].sT < positions[1].sT;
  };

  private isScrollExpectedPercent = (position) => {
    return (position.sT + position.cH) / position.sH > this.scrollPercent / 100;
  };
}
